import {connect} from 'react-redux';
import axios from 'axios';
import { Platform} from "react-native";
import {Tools} from "../../../../../tools/Tools";
import CategoryScreen from "../CategoryScreen";
import {typeExport} from "../../../../../redux/store/type";
import store from "../../../../../redux/store";
import {AsyngStorageClass} from "../../../../../tools/AsyngStorageClass";


const mapStateToProps = (state) => ({
    results: state.reducerCategoryScreen.results,
    isLoading: state.reducerCategoryScreen.isLoading,
    NoInternetDialog: state.reducerCategoryScreen.NoInternetDialog,

    resultsSet: state.reducerCategoryScreen.resultsSet,
    isLoadingSet: state.reducerCategoryScreen.isLoadingSet,
    NoInternetDialogSet: state.reducerCategoryScreen.NoInternetDialogSet,

    position: state.reducerCategoryScreen.position,
    id_category: state.reducerCategoryScreen.id_category,


    positionPersonnel: state.reducerCategoryScreen.positionPersonnel,
    id_Personnel: state.reducerCategoryScreen.id_Personnel,

    CartList: state.reducerSplashGetAllData.CartList,
    PriceAll: state.reducerSplashGetAllData.PriceAll,

    user: state.reducerSplashGetAllData.user,
    wallet: state.reducerSplashGetAllData.wallet,
    data_splash: state.reducerSplashGetAllData,
    // token: state.reducerSplash.token,

    FoodItem: state.reducerSplashGetAllData.FoodItem,
});

const mapDispatchToProps = (dispatch, getState) => ({
    callService: (url, params, type, typeConnection, token) => dispatch(callWebservice(getState, url, params, type, typeConnection, token)),

    callserviceActionRefresh: () => dispatch(serviceActionRefresh()),

});

const getDataDisatch = (dispatch, getState, url, params, type, typeConnection, token) => {

    switch (type) {
        case typeExport.TypeGetCategoryScreen:
            dispatch(serviceActionPending());

            break;

        case typeExport.TypeSetCategoryScreen:
            dispatch(serviceActionPendingSet());

            break;

        default:
    }

    var config = {
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        responseType: 'blob'
    };
    axios(
        {
            // url: baseUrl + url + params,
            url: typeExport.baseUrlWP + url,
            method: typeConnection,
            params: params,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            timeout: typeExport._TIMEOUT,
            /*      headers: {'X-Requested-With': 'XMLHttpRequest'},*/
        }
    ).then(async response => {
        let data = response.data;
        switch (type) {
            case typeExport.TypeGetCategoryScreen:
                //if (response.data.status === true) {
                // dispatch(serviceActionSuccess(data, token, response.data.user));

                if (data.status) {
                    await AsyngStorageClass.setAsyng(global.IdCity +typeExport.ListCategory+`${getState.route.params.item.id}`, data.menus)

                    dispatch(serviceActionSuccess(data.menus));
                }
                else {
                    switch (type) {
                        case typeExport.TypeGetCategoryScreen:
                            //  dispatch(serviceActionError("error"))
                            let data = await AsyngStorageClass.getASyng(global.IdCity +typeExport.ListCategory+`${getState.route.params.item.id}`)
                            //this.props.callServiceSuccess(data, 0)
                            if (data !== null)
                                dispatch(serviceActionSuccess(data))
                            else
                                dispatch(serviceActionSuccess([]))
                            break;

                        case typeExport.TypeSetCategoryScreen:
                            dispatch(serviceActionErrorSet("error"))

                            break;

                        default:
                    }
                }
                //   NavigationService.navigatereset('MainStack');
                // }
                // else {
                //  //   NavigationService.navigatereset('LoginStack');
                // }
                break;

            case typeExport.TypeSetCategoryScreen:

                break;

            default:
        }
    }).catch((e) => {

        switch (type) {
            case typeExport.TypeGetCategoryScreen:
                dispatch(serviceActionError(e))

                break;

            case typeExport.TypeSetCategoryScreen:
                dispatch(serviceActionErrorSet(e))

                break;

            default:
        }
    })
}


// export const callSetStateCity =  (state_name,state_id,city_name,city_id)  => {

//     return dispatch (serviceActionSuccessSetCityStateData (state_name,state_id,city_name,city_id) )
// }
export const callWebservice = (getState, url, params, type, typeConnection, token) => {
    return dispatch => {

        // if (Platform.OS === 'ios') {
        //     NetInfo.isConnected.addEventListener('connectionChange', (isConnected) => {
        //             if (isConnected) {
        //                 getDataDisatch(dispatch, getState,url, params, type, typeConnection, token);
        //             }
        //             else {
        //                 dispatch(serviceActionError("No Internet Connection"));
        //             }
        //         }
        //     );
        // }
        // else {
        // NetInfo.isConnected.fetch().then((isConnected) => {
        //     if (isConnected) {
        //         getDataDisatch(dispatch, getState, url, params, type, typeConnection, token);
        //     }
        //     else {
        //         switch (type) {
        //
        //             case typeExport.TypeGetCategoryScreen:
        //                 dispatch(serviceActionError("no connect"));
        //                 break;
        //             default:
        //         }
        //     }
        // });


            if (store.getState().reducerSplashGetAllData.Connection) {
                getDataDisatch(dispatch, getState, url, params, type, typeConnection, token);
            }
            else {
                switch (type) {

                    case typeExport.TypeGetCategoryScreen:
                        dispatch(serviceActionError('error_Connection'))

                        break;

                    case typeExport.TypeSetCategoryScreen:
                        dispatch(serviceActionErrorSet('error_Connection'))

                        break;

                    default:
                }
            }

        //}

        /* NetInfo.getConnectionInfo().done(
             (isConnected) => {
                 if (isConnected) {
                     getDataDisatch(dispatch, getState,url, params, type, typeConnection, token);
                 }
                 else {
                     switch (type) {

                         case typeExport.TypeGetCategoryScreen:
                             dispatch(serviceActionError("no connect"));
                             break;
                         default:
                     }
                 }
             }
         )*/
    }
}


export const serviceActionPending = () => ({
    type: typeExport.CategoryScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    showDialohCity: false

})

export const serviceActionError = (error) => ({
    type: typeExport.CategoryScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    error: error,
    isLoading: false,
    showDialohCity: false

})

export const serviceActionSuccess = (data) => ({
    type: typeExport.CategoryScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    results: data,
    isLoading: false,
})

export const serviceActionPendingSet = () => ({
    type: typeExport.CategoryScreen_SERVICE_PENDING_Set,
    NoInternetDialogSet: false,
    isLoadingSet: true,

})

export const serviceActionErrorSet = (error) => ({
    type: typeExport.CategoryScreen_SERVICE_ERROR_Set,
    NoInternetDialogSet: true,
    error: error,
    isLoadingSet: false,

})

export const serviceActionSuccessSet = (data) => ({
    type: typeExport.CategoryScreen_SERVICE_SUCCESS_Set,
    NoInternetDialogSet: false,
    resultsSet: data,
    isLoadingSet: false,
})
export const serviceActionRefresh = () => ({
    type: typeExport.CategoryScreen_SERVICE_REFRESH,
    NoInternetDialog: false,
    results: null,
    isLoading: false,
})


export default connect(mapStateToProps, mapDispatchToProps)(CategoryScreen);
